var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    stroke: "#500D76",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 14h5.334M8 11.333V14M2.667 2h10.666c.737 0 1.334.597 1.334 1.333V10c0 .736-.597 1.333-1.334 1.333H2.667A1.333 1.333 0 0 1 1.333 10V3.333C1.333 2.597 1.93 2 2.667 2z",
    stroke: "{stroke}",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorSmall);
export default __webpack_public_path__ + "static/media/monitorSmall.52fea54b78cf1f0ff187b795385209d9.svg";
export { ForwardRef as ReactComponent };